import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Яндекс метрика
const initYandexMetrika = (id) => {
    if (!window.ym) {
        window.ym = function() { (window.ym.a = window.ym.a || []).push(arguments); };
        window.ym.l = +new Date;

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://mc.yandex.ru/metrika/tag.js';

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    }

    window.ym(id, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        trackHash: true
    });
};

const YandexMetrikaTracker = () => {
    const location = useLocation();
    const METRIKA_ID = 99551720;

    useEffect(() => {
        initYandexMetrika(METRIKA_ID);
    }, []);

    useEffect(() => {
        if (window.ym && METRIKA_ID) {
            window.ym(METRIKA_ID, 'hit', location.pathname + location.search);
        }
    }, [location]);

    return null;
};

export default YandexMetrikaTracker;